import { DEFAULT_ITEM_SPECS_CONFIG } from '../constants/defaultItemSpecsConfig';

export const cloneItemSpecsConfig = (config) => ({
  defaults: (config?.defaults ?? []).map((d) => ({
    name: d.name ?? '',
    values: [...(d.values ?? [])],
    matchNames: [...(d.matchNames ?? [])],
    perSupplier: Boolean(d.perSupplier),
    perStore: Boolean(d.perStore),
    supplierValues: { ...(d.supplierValues ?? {}) },
    storeValues: { ...(d.storeValues ?? {}) },
  })),
  orderedAfterDefaults: (config?.orderedAfterDefaults ?? []).map((r) => ({
    name: r.name ?? '',
    matchNames: [...(r.matchNames ?? [])],
  })),
  endingOrdered: (config?.endingOrdered ?? []).map((r) => ({
    name: r.name ?? '',
    matchNames: [...(r.matchNames ?? [])],
  })),
  excluded: (config?.excluded ?? []).map((r) => ({
    name: r.name ?? '',
    matchNames: [...(r.matchNames ?? [])],
  })),
});

export const emptyDefaultSpec = () => ({
  name: '',
  values: [],
  matchNames: [],
  perSupplier: false,
  perStore: false,
  supplierValues: {},
  storeValues: {},
});

export const emptyNamedRule = () => ({
  name: '',
  matchNames: [],
});

export const resolveItemSpecsConfig = (config) => {
  const base = DEFAULT_ITEM_SPECS_CONFIG;
  const src = config ?? base;
  return cloneItemSpecsConfig({
    defaults: src.defaults ?? base.defaults,
    orderedAfterDefaults: src.orderedAfterDefaults ?? base.orderedAfterDefaults,
    endingOrdered: src.endingOrdered ?? base.endingOrdered,
    excluded: src.excluded ?? base.excluded,
  });
};

export const valuesToCommaString = (values) => (values ?? []).join(', ');

export const commaStringToValues = (str) =>
  String(str ?? '')
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean);

export const matchNamesToCommaString = (matchNames) => (matchNames ?? []).join(', ');

export const commaStringToMatchNames = (str) =>
  String(str ?? '')
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean);
